module.exports = __webpack_public_path__ + "img/envelope.067f0d41.png";